module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/pdf-documents/automatic-bill-discount/automatic-bill-discount.component.scss
// module id = ./src/app/components/pdf-documents/automatic-bill-discount/automatic-bill-discount.component.scss
// module chunks = main